// SearchAlert.js
// Recupera as features `alert`, `cowsValues`, `hasChangeCowsToBatch` e
// `changeCowsToBatch` que eram renderizadas pelo MainContainer.renderAlert
// (removido na F5). Pages IATF (D0, DN, DG, DGFinal, DGRessinc, IATF.js, etc)
// usam isso pra mostrar mensagens de erro de busca + card "mover matriz".
//
// Uso típico em pages IATF:
//   <SearchFilterRow
//     ...
//     alertSlot={
//       this.state.searchError && (
//         <SearchAlert
//           alert={this.state.searchError}
//           cowsValues={this.state.searchInputCow}
//           hasChangeCowsToBatch={...}
//           changeCowsToBatch={(item) => ...}
//         />
//       )
//     }
//   />

import React, { useState } from 'react'
import Alert from '@mui/material/Alert'
import CardToChangeCows from '../CardToChangeCows'
import Prompt from '../Prompt'

const MULTIPLE_ANIMALS_MSG = 'Há mais de um animal registrado com esse ID.'

export default function SearchAlert({
  alert,
  cowsValues,
  hasChangeCowsToBatch,
  changeCowsToBatch,
}) {
  const [modalOpen, setModalOpen] = useState(false)

  if (!alert) return null

  const hasMultiple = alert?.includes(MULTIPLE_ANIMALS_MSG)

  return (
    <>
      <Alert
        icon={false}
        style={{
          width: '100%',
          marginTop: '1em',
          marginBottom: '1em',
          backgroundColor: 'rgb(234, 93, 13)',
          color: 'white',
          fontWeight: 'bold',
        }}
      >
        {alert}
      </Alert>

      {hasChangeCowsToBatch &&
        !hasMultiple &&
        cowsValues?.length === 1 && (
          <CardToChangeCows
            text='Deseja mover essa matriz para esse lote?'
            buttonText='Mover'
            onClick={() => changeCowsToBatch(cowsValues[0])}
          />
        )}

      {hasChangeCowsToBatch &&
        hasMultiple &&
        cowsValues?.length >= 1 && (
          <>
            <CardToChangeCows
              text='Deseja mover alguma dessas matrizes?'
              buttonText='Clique aqui'
              onClick={() => setModalOpen(true)}
            />
            <Prompt
              visible={modalOpen}
              title='Animais registados com esse ID:'
              message={cowsValues?.map((item) => (
                <CardToChangeCows
                  key={item.id}
                  text={`Deseja mover a ${item.codVaca} do Lote ${item.nomeLote} para esse lote?`}
                  buttonText='Mover'
                  onClick={() => changeCowsToBatch(item)}
                />
              ))}
              buttons={[
                {
                  label: 'Cancelar',
                  onClick: () => setModalOpen(false),
                },
              ]}
            />
          </>
        )}
    </>
  )
}
